export type NativePlatform = 'android' | 'ios'

interface CapacitorRuntime {
  getPlatform?: () => unknown
  isNativePlatform?: () => boolean
}

interface CapacitorRuntimeContainer {
  Capacitor?: CapacitorRuntime
}

export function getNativePlatform(
  container: unknown = globalThis,
): NativePlatform | null {
  const capacitor = (container as CapacitorRuntimeContainer | null)?.Capacitor
  if (!capacitor) return null
  try {
    if (capacitor.isNativePlatform?.() === false) return null
    const platform = capacitor.getPlatform?.()
    return platform === 'android' || platform === 'ios' ? platform : null
  } catch {
    return null
  }
}

export async function removeNativeAppShellWorkers(
  registrations: Iterable<Pick<ServiceWorkerRegistration, 'unregister'>>,
  cacheStorage?: Pick<CacheStorage, 'delete' | 'keys'>,
): Promise<void> {
  await Promise.allSettled([...registrations].map((registration) => registration.unregister()))
  if (!cacheStorage) return
  let cacheNames: string[]
  try {
    cacheNames = await cacheStorage.keys()
  } catch {
    return
  }
  await Promise.allSettled(
    cacheNames
      .filter((cacheName) => cacheName.startsWith('minimany-shell-'))
      .map((cacheName) => cacheStorage.delete(cacheName)),
  )
}
